import { render, staticRenderFns } from "./parentView.vue?vue&type=template&id=999b96ba"
import script from "./parentView.vue?vue&type=script&lang=js"
export * from "./parentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports